import { SettingsSectionLabel } from "@/components/settings/settings-section-label";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { ReactNode } from "react";

interface LabelContainerProps {
  label: string;
  htmlFor?: string;
  className?: string;
  error?: string;
  showErrorMessage?: boolean;
  /** Visual theme. "dark" = white label for dark backgrounds; "settings" = same as light but accepted by type. */
  theme?: "light" | "dark" | "settings";
  children: ReactNode;
}

export function LabelContainer({
  label,
  htmlFor,
  className,
  error,
  showErrorMessage = true,
  theme = "light",
  children,
}: LabelContainerProps) {
  return (
    <div className={cn("flex w-full flex-col gap-2", className)}>
      {theme === "settings" ? (
        <SettingsSectionLabel label={label} />
      ) : (
        <label
          role="label"
          htmlFor={htmlFor}
          className={cn(textVariants.inputLabel, theme === "dark" && "text-white")}
        >
          {label}
        </label>
      )}
      {children}
      {showErrorMessage && error && (
        <p className={cn(textVariants.bodySmall, "text-red-500")}>{error}</p>
      )}
    </div>
  );
}

export default LabelContainer;
